import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { LoadingService } from '../services/loading.service';
import { finalize } from 'rxjs/operators';

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService);

  if (req.headers.has('Skip-Loading') && req.headers.get('Skip-Loading') === 'true') {
    const cleanReq = req.clone({ headers: req.headers.delete('Skip-Loading') });
    return next(cleanReq);
  }

  const urlLower = req.url.toLowerCase();
  if (urlLower.includes('blob.core.windows.net') || urlLower.includes('?sv=') || urlLower.includes('&sig=')) {
    return next(req);
  }

  loadingService.show();

  return next(req).pipe(
    finalize(() => {
      loadingService.hide();
    })
  );
};
